<template>
  <!--subPage 상단 Navi-->
  <div class="sub_Navi">
    <ul>
      <li><a class="back" href="javascript:window.history.back();">뒤로</a></li>
      <li>
        <h1>{{ $t("mypage.mySubInfo") }}
        
        </h1>
      </li>
      <li class="linkBox"></li>
    </ul>
  </div>
  <!--//subPage 상단 Navi :End-->
  <!--subPage -->
  <!-- <div class="subPage_container"> -->
  <div class="subPage_container" v-if="subScribe">
    <div class="subscribe_wrap">
      <!-- 나의 구독정보 / 임의 권한 -->
      <div class="subscribe_infobox"
        v-if="subscribeList.packagePrice != 0 && forcing">
        <div class="goods_img">
          <img :src="getImagePath()" />
          <!-- <img
            :src="`@/assets/images/common/goods_${subscribeList.packagePrice}.png`"
          />  -->
          <!-- <img src="@/assets/images/common/goods_5000.png" /> -->
        </div>
        <div class="goods_price">
          <h5>
            {{ $t("mypage.chartPackage") }}
          </h5>
          <h3 class="num">${{ subscribeList.packagePrice }}</h3>
          <!-- <a href="#none" class="">{{ $t("mypage.buyPackage") }}</a> -->
        </div>
      </div>
      <!--나의 구독정보-->
      <div class="subscribe_infobox"
        v-if="!forcing && subscribeList.packagePrice != 0 && chartDate > 0 && subscribeList.chartStartDate !== '' && subscribeList.chartEndDate !== ''">
        <div class="goods_img">
          <img :src="getImagePath()" />
          <!-- <img
            :src="`@/assets/images/common/goods_${subscribeList.packagePrice}.png`"
          />  -->
          <!-- <img src="@/assets/images/common/goods_5000.png" /> -->
        </div>
        <div class="goods_price">
          <h5>
            {{ $t("mypage.chartPackage") }}
          </h5>
          <h3 class="num">${{ subscribeList.packagePrice }}</h3>
          <!-- <a href="#none" class="">{{ $t("mypage.buyPackage") }}</a> -->
        </div>
      </div>
    </div>
    <div class="subscribe_data_wrap" v-if="!premiumForcing">
      <h3 class="title">{{ $t("mypage.subDate") }}</h3>
      <div
        v-if="subscribeList.packagePrice != 0 && chartDate > 0 && subscribeList.chartStartDate !== '' && subscribeList.chartEndDate !== ''"
        class="chart--sub-top"
        >
        <h5 class="time_info">
          <p>
            {{ subscribeList.chartStartDate }} ~
            {{ subscribeList.chartEndDate }} (D-{{ chartTotal }})
          </p>
          <span class="num"><em v-dompurify-html="$t('mypage.dueDate', { day: chartDate })"></em></span>
        </h5>
        <div class="time_wrap">
          <div class="graphic chart" :style="{ width: chartPercentage + '%' }"></div>
          <!--총서비스 일수에서 남은일수 %계산값-->
        </div>
      </div>
      <div class="subscribe_nodata_alarm"
        v-if="subScribe && subscribeList.packagePrice === 0 || chartDate <= 0 || subscribeList.chartStartDate === '' || subscribeList.chartEndDate === ''">
        {{ $t('mypage.noChart') }}
      </div>

      <h3 class="title alarm">{{ $t("mypage.alarmSubPeriod") }}</h3>

      <div v-if="subscribeList.alarmStartDate != '' && subscribeList.alarmEndDate != '' && alarmDate > 0">
        <h5 class="time_info" id="subscribe">
          <p>
            {{ subscribeList.alarmStartDate }} ~
            {{ subscribeList.alarmEndDate }} (D-{{ alarmTotal }})
          </p>
          <span class="num"><em v-dompurify-html="$t('mypage.dueDate', { day: alarmDate })"></em></span>
        </h5>
        <div class="time_wrap">
          <div class="graphic alarm" :style="{ width: alarmPercentage + '%' }"></div>
        </div>
      </div>
      <div v-if="subscribeList.alarmStartDate === '' || subscribeList.alarmEndDate === '' || alarmDate <= 0">
        <h5 class="subscribe_nodata_alarm"> {{ $t('mypage.noAlarm') }} </h5>
      </div>
    </div>
  </div>
  <!--//subPage_container :End -->
  <!--//subPage :End -->

  <!-- popup message -->
  <div class="popupMessage">
    <span class="messageTxt"></span>
  </div>
  <!-- popup message end -->
</template>

<script>
import api from "@/api/apiUser";
import apiAuth from "@/api/apiAuth";
import { mapState } from "vuex";

export default {
  name: "SubscribeInfo",
  data() {
    return {
      subscribeList: [],
      toDay: null,
      chartDate: null,
      chartTotal: null,
      alarmDate: null,
      alarmTotal: null,
      chartPercentage: 0,
      alarmPercentage: 0,
      subScribe: false,
      forcing: false,
      premiumForcing: false,
    };
  },
  computed: {
    ...mapState("user", ["subScribe"])
  },
  async beforeCreate() {
    // subscribe get api 호출
    try {
      this.subScribe = true;
      const permission = await apiAuth.chkUserPermission();

      // 오늘 날짜 가져오는 함수
      try {
        const todayDate = Date.now();
        const today = new Date(todayDate);
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const date = String(today.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${date}`;
        this.toDay = formattedDate;
      } 
      catch (error) {
        console.error("Error get today:", error);
      }
      
      // permission.data.isRegistered = true;
      // permission.data.isSmart = true;
      // permission.data.isPremium = true;
      const endDateValue = permission?.data?.endDate;

      let isPassed = true;

      if (endDateValue) {
        const endDate = new Date(endDateValue);
        const today = new Date();

        endDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        isPassed = endDate < today;
      }

      // console.log("endDate", endDateValue);
      // console.log("오늘 기준 지났는지", isPassed);

      if (permission.data.isRegistered && !isPassed) {
        if (permission.isSuccess) {
          this.subScribe = true;
          this.forcing = true;
          
          if (permission.data.isSmart) {
            this.subscribeList.packagePrice = 10000;
            this.subscribeList.chartStartDate = "2025-05-20"
            this.subscribeList.chartEndDate = "2027-05-20"
            this.subscribeList.alarmStartDate = "2025-05-20"
            this.subscribeList.alarmEndDate = "2027-05-20"
            this.chartDays();
            this.alarmDays();
          }

          else if (permission.data.isPremium) {
            this.subscribeList.packagePrice = 5000;
            this.premiumForcing = true;
          }

          else {
            await this.getSubscribe();
          }
        }
      }
      else {
        await this.getSubscribe();
      }
    } 
    catch (error) {
      console.error("Error get subscribe:", error);
    }

  },

  methods: {
    // 구독 정보 가져오는 함수
    async getSubscribe() {
      const response = await api.getSubscribe();

      if (response.isSuccess) {
        this.subScribe = true;

        // 날짜 형식 YYYY-MM-DD 로 변경 함수
        for (let key in response.data) {
          if (Object.hasOwnProperty.call(response.data, key)) {
            let value = response.data[key];
            if (typeof value === "string" && value != "") {
              let year = value.substring(0, 4)
              let month = value.substring(4, 6)
              let day = value.substring(6, 8)
              let Date = `${year}-${month}-${day}`;

              response.data[key] = Date
            }
          }
        }

        // packagePrice 이미지 범위로 변경
        for (let key in response.data) {
          if (Object.hasOwnProperty.call(response.data, key)) {
            let value = response.data[key];
            if (typeof value === "number") {
              if (value > 1 && value < 3000) {
                response.data[key] = 1000;
              } else if (value >= 3000 && value < 5000) {
                response.data[key] = 3000;
              } else if (value >= 5000 && value < 10000) {
                response.data[key] = 5000;
              } else if (value >= 10000) {
                response.data[key] = 10000;
              }

            }
          }
        }

        this.subscribeList = response.data;

        this.chartDays();
        this.alarmDays();
      }
      else {
        return;
      }
    },

    // 구독 기간
    chartDays() {
      const start = new Date(this.subscribeList.chartStartDate);
      const end = new Date(this.subscribeList.chartEndDate);
      // console.log('start', start)
      // console.log('end', end)
      
      const timeDiff = end - start;
      // console.log('timeDiff', timeDiff)
      this.chartTotal = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

      const day = new Date(this.toDay);
      const timeNow = end - day;
      this.chartDate = Math.ceil(timeNow / (1000 * 60 * 60 * 24));

      this.chartPercentage = (this.chartDate / this.chartTotal) * 100;
    },

    // 알람 기간
    alarmDays() {
      const start = new Date(this.subscribeList.alarmStartDate);
      const end = new Date(this.subscribeList.alarmEndDate);

      const timeDiff = end - start;
      this.alarmTotal = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

      const day = new Date(this.toDay);
      const timeNow = end - day;
      this.alarmDate = Math.ceil(timeNow / (1000 * 60 * 60 * 24));

      this.alarmPercentage = (this.alarmDate / this.alarmTotal) * 100;
    },

    // 가격별 이미지 호출
    getImagePath() {
      if (this.subscribeList.packagePrice === undefined) {
        return;
      } else {
        return require("@/assets/images/goods/goods_" +
          this.subscribeList.packagePrice +
          ".png");
      }
    },
  },
};
</script>